import fixedElements from './toggleFIxedElements';
import { setCookie, getCookie } from './helpers';
import { Modal } from './lib/modal.ts';

const DOM = {};
const POPUP_COOKIE = '_popupDismissed';
const POPUP_PROMO_COOKIE = '_popupPromoDismissed';

const cacheDOM = () => {
    DOM.searchModal = document.querySelector('#search-modal');
    DOM.formModal = document.querySelector('#form-modal');
    DOM.requestCallModal = document.querySelector('#request-call-modal');
    DOM.nav = document.querySelector('.nav');
    DOM.navListItems = document.querySelectorAll('.nav__listItem');
    DOM.openMenuElement = document.querySelector('.nav__link--open-menu');
    DOM.openEnquireForm = document.querySelectorAll('.open-enquire-form');
    DOM.extraModals = document.querySelectorAll('[data-blmodal-open]');
    DOM.popupModal = document.getElementById('popup-form-modal');
    DOM.popupPromoModal = document.getElementById('popup-promo-form-modal');
};

const toggleModal = () => {
    DOM.navListItems.forEach((item) => {
        const link = item.firstElementChild;
        if (link !== DOM.openMenuElement) {
            item.classList.toggle('nav__listItem--hide');
        }
    });

    if (Modal.isOpen()) {
        DOM.nav.classList.add('nav--has-modal');
    } else {
        DOM.nav.classList.remove('nav--has-modal');
    }

    fixedElements.toggleNavModal();

    /* Check for IE as it doesnt let you change classes in svg elements */
    if (DOM.openMenuElement.firstElementChild.classList) {
        DOM.openMenuElement.firstElementChild.classList.toggle('svg-close');
    }
};

const createSearchModal = () => {
    const searchModal = Modal.init({
        modal: DOM.searchModal,
        openTriggers: '.nav__link--open-search',
        closeTriggers: [
            DOM.openMenuElement,
            document.querySelector('[data-slidemodal-close]'),
        ],
        openClasses: ['slide-modal--open'],
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        disableFocus: false,
        disableScroll: true,
        onShow: toggleModal,
        onClose: toggleModal,
    });
};

const createFormModal = () => {
    if (DOM.openEnquireForm[0]) {
        const isScroll = DOM.openEnquireForm[0].dataset.scroll;
        const inPageForm = document.getElementById('form');

        if (isScroll === 'True' && inPageForm) return;

        const formModal = Modal.init({
            modal: DOM.formModal,
            openTriggers: '.open-enquire-form',
            closeTriggers: [
                DOM.openMenuElement,
                document.querySelector('[data-slidemodal-close]'),
            ],
            openClasses: ['slide-modal--open'],
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
            disableFocus: false,
            disableScroll: true,
            onShow: toggleModal,
            onClose: toggleModal,
        });
    }
};

const createExtraModals = () => {
    DOM.extraModals.forEach((modalTrigger) => {
        const modal = document.querySelector(modalTrigger.dataset.blmodalOpen);
        if (!modal) return;

        Modal.init({
            modal,
            openTriggers: [modalTrigger],
            closeTriggers: [DOM.openMenuElement],
            openClasses: ['slide-modal--open'],
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
            disableFocus: false,
            disableScroll: true,
            onShow: toggleModal,
            onClose: toggleModal,
        });
    });
};

// TODO: extract to separate file
const createPopupModal = () => {
    // If the user has the cookie, do nothing
    if (getCookie(POPUP_COOKIE)) return;

    const popup = Modal.init({
        modal: DOM.popupModal,
        closeTriggers: '[data-modal-close]',
        openClasses: ['popup-modal--open'],
        awaitOpenAnimation: true,
        awaitCloseAnimation: false,
        disableFocus: true,
        disableScroll: false,
        onClose: () => {
            // Disable the popup for the next 1 days
            setCookie(POPUP_COOKIE, true, 1);
        },
    });

    // Close the modal automatically in small resolutions
    const mq = matchMedia('(min-width: 768px)');
    //mq.addListener(() => {
    //    if (!mq.matches) popup.show();
    //});

    // Open the modal after X ms (default: 30s)
    const timer = DOM.popupModal.dataset.modalTimer || 30000;
    setTimeout(() => {
        //if (mq.matches)
        popup.show();
    }, timer);

    //if (mq.matches) popup.show();
};

const createPopupPromoModal = () => {
    // If the user has the cookie, do nothing
    if (getCookie(POPUP_PROMO_COOKIE)) return;

    const popup = Modal.init({
        modal: DOM.popupPromoModal,
        closeTriggers: '[data-promo-modal-close]',
        openClasses: ['popup-promo-modal--open'],
        awaitOpenAnimation: true,
        awaitCloseAnimation: false,
        disableFocus: true,
        disableScroll: false,
        onClose: () => {
            // Disable the popup for the next 1 days
            setCookie(POPUP_PROMO_COOKIE, true, 1);
        },
    });

    // Close the modal automatically in small resolutions
    const mpq = matchMedia('(min-width: 768px)');
    // mpq.addListener(() => {
    //     if (!mpq.matches) popup.show();
    // });

    // Open the modal after X ms (default: 30s)
    const promotimer = DOM.popupPromoModal.dataset.modalTimer || 30000;
    // if (mpq.matches) popup.show();
    setTimeout(() => {
        popup.show();
        // if (mpq.matches)
    }, promotimer);
};

const createRequestCallModal = () => {
    if (DOM.openEnquireForm[0]) {
        const isScroll = DOM.openEnquireForm[0].dataset.scroll;
        const inPageForm = document.getElementById('form');
        if (isScroll === 'True' && inPageForm) return;
        const requestCallModal = Modal.init({
            modal: DOM.requestCallModal,
            openTriggers: '.open-request-call-form',
            closeTriggers: '[data-popup-close]',
            openClasses: ['popup-modal--open-call'],
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
            disableFocus: false,
            disableScroll: true
        });
    }
};

const init = () => {
    cacheDOM();

    if (window.location.search.includes('popup=true'))
        setCookie(POPUP_COOKIE, true, 60);

    if (window.location.search.includes('popuppromo=true'))
        setCookie(POPUP_PROMO_COOKIE, true, 60);

    if (DOM.searchModal) createSearchModal();
    if (DOM.extraModals) createExtraModals();
    if (DOM.formModal) createFormModal();
    if (DOM.popupModal) createPopupModal();
    if (DOM.popupPromoModal) createPopupPromoModal();
    if (DOM.requestCallModal) createRequestCallModal();
};

const modals = { init };
export default modals;
